<template>
  <div class="ma-4">
    <div class="mb-3">
      <span class="main-title">ORDER RECEIPT |</span>
      <span class="submain-title">Messenger receipt</span>
    </div>
    <MessengerReceiptList />
  </div>
</template>

<script>
import MessengerReceiptList from "@/components/back-office/Report/MessengerReceiptListTable";
export default {
  components: {
    MessengerReceiptList
  },
  destroyed() {
    this.$store.commit("fetchReportMessenger/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Messenger receipt",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/order_report_messenger"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
